import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import noop from 'lodash/noop'

import { getDefaultSelected, makeDefaultSelectedTrue } from '../store'
import StatusBarRangeSelection from './StatusBarRangeSelection'
import { useGridApi } from './gridApi'

function onKey(params, api) {
  let previousCell = params.previousCellPosition
  const suggestedNextCell = params.nextCellPosition

  if (!suggestedNextCell || suggestedNextCell?.rowIndex < 0) {
    return
  }

  const KEY_UP = 38
  const KEY_DOWN = 40
  const KEY_LEFT = 37
  const KEY_RIGHT = 39

  switch (params.event.keyCode) {
    case KEY_DOWN:
      // set selected cell on current cell + 1
      api.forEachNode((node) => {
        if (previousCell.rowIndex + 1 === node.rowIndex) {
          node.setSelected(true)
        }
      })
      return suggestedNextCell
    case KEY_UP:
      // set selected cell on current cell - 1
      api.forEachNode((node) => {
        if (previousCell.rowIndex - 1 === node.rowIndex) {
          node.setSelected(true)
        }
      })
      return suggestedNextCell
    case KEY_LEFT:
    case KEY_RIGHT:
      return previousCell
    default:
      return suggestedNextCell
  }
}

export const SelectionWithArrowKeys = (props) => {
  const { instanceName, iSelectFirstRow, iSelectLastRow } = props

  const dispatch = useDispatch()

  const defaultSelected = useSelector((state) => getDefaultSelected(state, instanceName))

  const gridApi = useGridApi(props.instanceName)

  const ref = React.useRef(gridApi)

  const handleNavigateToNextCell = (params) => {
    return ref.current?.api && onKey(params, ref.current.api)
  }

  React.useEffect(() => {
    if (gridApi) {
      ref.current = gridApi
    }
  }, [gridApi])

  const handleGridReady = ({ api }) => {
    const selectRowSafely = () => {
      const rowModel = api.getModel()

      const lastRowIndex = rowModel.getRowCount() - 1

      const rowToSelect = iSelectFirstRow ? api.getDisplayedRowAtIndex(0) : api.getDisplayedRowAtIndex(lastRowIndex)

      if (rowToSelect) {
        rowToSelect.setSelected(true, true)

        if (iSelectLastRow) {
          api.ensureIndexVisible(lastRowIndex)
        }
      }
    }

    if (!defaultSelected) {
      selectRowSafely()

      dispatch(makeDefaultSelectedTrue(instanceName))
    }

    api.addEventListener('rowDataChanged', selectRowSafely)
  }

  if (iSelectFirstRow && iSelectLastRow) {
    console.error(
      "LKGrid, default row selection: selectFirstRow and selectLastRow props are both true, you can't select both rows",
    )
  }

  return (
    <StatusBarRangeSelection
      {...props}
      navigateToNextCell={handleNavigateToNextCell}
      defaultSelectionsOnGridReady={iSelectFirstRow || iSelectLastRow ? handleGridReady : noop}
    />
  )
}
